import React from 'react';
import { Box, IconButton, SxProps, Theme, styled } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const Container = styled(Box)({
  position: 'absolute',
  backgroundColor: 'white',
  opacity: 0.95,
  top: '15px',
  width: '320px',
  maxWidth: 'calc(100vw - 16px)',
  zIndex: 100
});

type MapSplitsContainerProps = {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  defaultExpanded?: boolean;
};

const MapSplitsContainer: React.FC<MapSplitsContainerProps> = ({
  children,
  sx,
  defaultExpanded = true
}) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  if (!expanded) {
    return (
      <IconButton
        color="primary"
        size="small"
        onClick={() => setExpanded(true)}
        aria-label="expand times"
        sx={{
          position: 'absolute',
          top: '10px',
          zIndex: 100,
          background: '#ffffffaa',
          ...sx
        }}
      >
        <KeyboardArrowDownIcon />
      </IconButton>
    );
  }

  return (
    <Container sx={sx}>
      <IconButton
        size="small"
        onClick={() => setExpanded(false)}
        aria-label="collapse times"
        sx={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}
      >
        <KeyboardArrowUpIcon />
      </IconButton>
      {children}
    </Container>
  );
};

export default MapSplitsContainer;
